import { IQueryLog } from '@common/types';
import { PYTHON_BACKEND } from '@constants/env';
import { ApiEndpoint, ContentType, HttpHeader, HttpMethod, HttpStatus } from '@constants/http';

export async function storeQueryLog(query: string): Promise<IQueryLog | void> {
  const baseUrl = PYTHON_BACKEND;
  const endpoint = ApiEndpoint.QueryLogs;
  const url = `${baseUrl}/${endpoint}/`;
  const requestOptions = {
    method: HttpMethod.POST,
    headers: {
      [HttpHeader.ContentType]: ContentType.JSON,
    },
    body: JSON.stringify({ query }),
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.json();

    if (!response.ok) {
      if (response.status === HttpStatus.InternalServerError) {
        throw new Error('[api.store-query-log]: Internal Server Error');
      }
      if (data && data.message) {
        throw new Error(data.message);
      }
      throw new Error('[api.store-query-log]: Something went wrong!');
    }

    return data;
  } catch (error: unknown) {
    console.error(error);
  }
}
